// app.js REQUIRED
import APP from "../../utils/app.js"

import { el, mount, svg } from "redom"
import { backToApp } from "../../utils/appFunctions.js"
import { initButtons } from "../helpers/collapse.js"
import { openMainFeedOnClick } from "../pages/mainfeedpage.js"
import { getAuthUserWithHandlingError as getAuthUser, maybeMeIsMe } from '../../utils/authUser.js'
import { displaySignInButtonOnTopMenu } from "../../login/login-display.js"
import { openUserPageOnClick } from "../pages/userpage.js"
import { goTuner, addRecord, displayCookiePopUp, agreeCookie } from "../helpers/layoutwithapp.js"
import { buildBottomSoundcorset, buildBottomLinks } from "../../utils/layout.js"
import { privacyPolicyLink } from "../../utils/internationalization.js"
import type { MaybeUser } from "#/types.js"

export default async function initLayout() {
    const embed: boolean = APP.getParameterFromUrl("embed") == "true"
    const maybeMe = await getAuthUser()
    const topContainer = document.getElementById("topContainer");
    const bottomContainer = document.getElementById("bottomContainer");
    const embedTopPadding = document.getElementById("embedTopPadding");
    const contentsMain = document.getElementById("contents-main");
    if (!embed && topContainer) {
        mount(topContainer, buildTopMenuContainer(maybeMe));
    }

    if (!maybeMe.isDefined) displaySignInButtonOnTopMenu()
    if (embed && embedTopPadding) embedTopPadding.style.paddingTop = "0px"
    else if (bottomContainer) mount(bottomContainer, buildBottomMenuContainer())
    initButtons()

    if (bottomContainer && contentsMain && embedTopPadding) {
        const bottomHeight: number = bottomContainer.offsetHeight
        const topPadding = parseInt(embedTopPadding.style.paddingTop, 10)
        contentsMain.style.minHeight = "calc(100vh - " + ( topPadding + bottomHeight ) + "px)"
    }
    displayCookiePopUp()
}

APP.featureActivations["goTuner"] = { "android": APP.CHECKBUILDDATE,     "iOS": APP.NEVER,     "buildDate": 220627 }

const searchIconSVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
`
const searchSVGUri = `data:image/svg+xml;base64,${btoa(searchIconSVG)}`;

const buildTopMenuContainer = (maybeMe: MaybeUser): HTMLDivElement =>
    el("div", { className: "container-fluid top" },
        el("div.sc-contents-wrap vertical-center-in-div", { style: "display: flex; flex-wrap: wrap; padding-left: 5px;" },
            el("div.col-auto layoutTopItem#previous-button", { onclick: () => window.history.back(), style: "display: none" },
                el("img.layoutTopBackButton.goto-previous-buttons", { src: "/public/static/image/img_goto_previous.svg", style: "padding: 0px;" })
            ),
            el("div.col-auto.layoutTopItem#phone-feature", { align: "left", onclick: openMainFeedOnClick, style: "display: none" },
                el("img.layoutTopButton.svg-buttons", { src: "/public/img/img_shared_records.svg" })
            ),
            el("div.col-auto.layoutTopItem#backToApp-button", { onclick: backToApp, style: "display: none" },
                el("img.layoutTopButton.metro-button.rounded-btn", { src: "/public/img/img_metronome.svg"})
            ),
            el("div.col-auto.layoutTopItem#go-tuner-button", { onclick: goTuner, style: "display: none;" },
                el("img.layoutTopButton.svg-buttons", { src: "/public/img/tuner.svg"})
            ),
            el("div.col-auto.layoutTopItem#add-record-button", { onclick: addRecord, style: "display: none" },
                el("img.layoutTopButton.svg-buttons", { src: "/public/img/img_plus.svg" })
            ),
            el("div.col-auto.noPadding#web-feature", { style: "display: none", onclick: openMainFeedOnClick },
                el("img.clickable", { src: "/public/img/soundcorset_logo_black.png", height: 26, style: "margin: 17px 0 17px 5px; filter: invert(var(--inversion-amount));" })
            ),
            el("div.ms-auto"),
            el("div.col-auto.layoutTopItem#search-button", { style: "display: none" },
                    el("img.layoutTopButton.svg-buttons#search-icon", { src: searchSVGUri, alt: "search", "data-bs-toggle": "modal", "data-bs-target": "#searchModal", style: {"border-radius": "10px"} },
                    )
            ),
            el("div#user-login-col",
                maybeMeIsMe(maybeMe) ?
                el("div.right", { style: "padding: 7px 7px 7px 0; height: 100%;"},
                    el("a.clickable", { onclick: () => openUserPageOnClick(maybeMe.get.id)},
                        el("img#profileImg.rounded-circle", { src: maybeMe.get.imgUrl, width: 46, height: 46, onerror: (e: Event) => { (e.target as HTMLImageElement).src = "/public/img/icon200x200.png" } })
                    )
                )
                : el("")
            )
        )
    )

const buildBottomMenuContainer = (): HTMLDivElement =>
    el("div",
        el("#cookie-policy",
            el(".row sc-contents-wrap", { style: "padding: 20px;" },
                el(".col noPadding", { style: "font-size: 13px; color: white;" },
                    "By using our service, you acknowledge that you have read and understand our ",
                    el("a", { href: "/public/useofcookies.html?back" }, "Cookie Policy"), ", ",
                    el("a", { href: privacyPolicyLink() }, 
                    "Privacy Policy"), ", and our ",
                    el("a", { href: "/public/termsofuse.html?back" }, "Terms of Service"), "."
                ),
                el(".col-auto noPadding", { width: "30" },
                    svg("svg.svg-icon m0 iconClear", { "aria-hidden": "true", width: 18, height: 18, "viewBox": "0 0 18 18", style: "margin: auto; display: inline-block; vertical-align: bottom;", onclick: () => agreeCookie() },
                        svg("path", { d: "M15 4.41L13.59 3 9 7.59 4.41 3 3 4.41 7.59 9 3 13.59 4.41 15 9 10.41 13.59 15 15 13.59 10.41 9z" } )
                    )
                )
            )
        ),
        buildBottomSoundcorset(),
        buildBottomLinks()
    )
